import './honorific-block-times-list-item.scss';

import { kebabCase } from 'lodash';
import { useMemo } from 'react';

import { HonorificBlockTimeItemDataFragment } from '../../../data/types/api/graphql';
import { makeKeyDownHandler } from '../../../data/utils/make-key-down-handler';
import { CustomFormattedMessage } from '../../../elements/intl/custom-formatted-message';

type HonorificBlockTimesListItemProps = {
  item: HonorificBlockTimeItemDataFragment;
  onClick?: (value: HonorificBlockTimeItemDataFragment) => void;
};

export function HonorificBlockTimesListItem({
  onClick,
  item,
}: HonorificBlockTimesListItemProps) {
  const attributes = useMemo(() => {
    if (onClick) {
      return {
        role: 'button',
        tabIndex: 0,
        onClick: () => onClick(item),
        onKeyDown: makeKeyDownHandler(() => onClick(item)),
      };
    }

    return {};
  }, [item, onClick]);

  return (
    <div
      {...attributes}
      className={`honorific-block-times-list-item${
        item.active ? ' honorific-block-times-list-item--active' : ''
      }`}
    >
      <div className="honorific-block-times-list-item__content">
        <h2>
          <CustomFormattedMessage
            id={`common.honorific.${kebabCase(item.honorific)}`}
          />
        </h2>
      </div>
      <div className="honorific-block-times-list-item__content">
        <h3>
          <CustomFormattedMessage id="admin.honorific-block-times.block-minutes-description" />
        </h3>
        <p>{item.blockMinutes}</p>
      </div>
      <div className="honorific-block-times-list-item__content">
        <h3>
          <CustomFormattedMessage id="admin.honorific-block-times.fallback-block-minutes-description" />
        </h3>
        <p>{item.fallBackMinutes}</p>
      </div>
      <div className="honorific-block-times-list-item__content">
        <h3>
          <CustomFormattedMessage id="admin.honorific-block-times.edit-appointment-before-hours-description" />
        </h3>
        <p>{item.editAppointmentBeforeHours}</p>
      </div>
      <div className="honorific-block-times-list-item__content">
        <h3>
          <CustomFormattedMessage id="admin.honorific-block-times.snap-description" />
        </h3>
        <p className={item.snap ? 'active' : ''}>
          <CustomFormattedMessage id={item.snap ? 'common.on' : 'common.off'} />
        </p>
      </div>
    </div>
  );
}
